// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-512e2692] {\n  margin: 1.2em 0;\n}\n.quote-width[data-v-512e2692] {\n  width: 150px;\n}", ""]);
// Exports
module.exports = exports;
